import React from 'react';
import './Notepad.css';

// Notepad — HER NOTES, VISIBLE. 2026-08-12 (ARIA_VISUAL_DOCTRINE.md §3.3).
//
// Braeden: "on the right hand side pull up a notepad or something to take
// notes on the oppinion of waht the user like and doesnt."
//
// The case file has taken these notes since 8/22 (ariaCaseFile.js) — this
// makes them VISIBLE. Pinned right (his call, 8/12: it must stay visible
// while assist drives the screen), riding along for the whole session.
//
// HONESTY: every row here is from the case file — what he actually said and
// what she ticked off. Nothing is rendered that isn't in the file, so the
// notepad can never claim she heard something she didn't. Same no-empty rule
// as the workstation: no case file, no notepad, no placeholder.
export default function Notepad({ caseFile, onClose }) {
  if (!caseFile) return null;
  const checklist = Array.isArray(caseFile.checklist) ? caseFile.checklist : [];
  const notes = Array.isArray(caseFile.notes) ? caseFile.notes : [];
  if (!checklist.length && !notes.length && !caseFile.problem) return null;

  return (
    <aside className="notepad" aria-label="Aria's notes">
      <div className="notepad__head">
        <span className="notepad__title">Notes</span>
        {onClose && (
          <button type="button" className="notepad__close" onClick={onClose} aria-label="Close notes">×</button>
        )}
      </div>

      {caseFile.problem && (
        <div className="notepad__problem">{caseFile.problem}</div>
      )}

      {checklist.length > 0 && (
        <>
          {/* The page holds what is SETTLED (8/31) - it starts blank and she
              writes each line as it lands. A "1/1" fraction on a list of only
              finished items always read as done-and-dusted while the job was
              two questions old. */}
          <div className="notepad__kicker">Written down</div>
          <ul className="notepad__list">
            {checklist.map((c) => (
              <li key={c.key || c.label} className={c.done ? 'is-done' : ''}>
                <i>{c.done ? '✓' : '○'}</i>
                <span>{c.label}</span>
                {c.done && c.value && <b>{c.value}</b>}
              </li>
            ))}
          </ul>
        </>
      )}

      {notes.length > 0 && (
        <>
          <div className="notepad__kicker">What you told me</div>
          <ul className="notepad__notes">
            {notes.slice(-14).map((n, i) => (
              <li key={i}>{typeof n === 'string' ? n : n.text}</li>
            ))}
          </ul>
        </>
      )}
    </aside>
  );
}
